import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  BookingOfficesResponse,
  ReadStatistcsResponse,
  ReadTopRatesResponse
} from '../services/dashboard.model';
import { ActionTypes } from '../actions/actions-dashboard';
import * as DashboardActions from '../actions/actions-dashboard';
import { TopRatesTransformerService } from '../services/top-rates-transformer.service';
import { BackendDashboardService } from '../services/backend-dashboard.service';

@Injectable()
export class EffectsAvcDashboard {

  setCurrentChart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetCurrentChart),
      switchMap((action: any) =>
        this.dashboardService.readStatistcs(action.statisticFilter).pipe(
          map(
            (response: ReadStatistcsResponse) =>
              new DashboardActions.SetCurrentChartSuccess(response.monthlyStatistics, response.kpis)
          ),
          catchError(error => of(new DashboardActions.SetCurrentChartError(error)))
        )
      )
    );
  });

  setOneYearAgoChart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetOneYearAgoChart),
      switchMap((action: any) =>
        this.dashboardService.readOneYearAgoStatistcs(action.statisticFilter).pipe(
          map(
            (response: ReadStatistcsResponse) =>
              new DashboardActions.SetOneYearAgoChartSuccess(response.monthlyStatistics, response.kpis)
          ),
          catchError(error => of(new DashboardActions.SetOneYearAgoChartError(error)))
        )
      )
    );
  });

  setTwoYearsAgoChart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetTwoYearsAgoChart),
      switchMap((action: any) =>
        this.dashboardService.readTwoYearsAgoStatistcs(action.statisticFilter).pipe(
          map(
            (response: ReadStatistcsResponse) =>
              new DashboardActions.SetTwoYearsAgoChartSuccess(response.monthlyStatistics)
          ),
          catchError(error => of(new DashboardActions.SetTwoYearsAgoChartError(error)))
        )
      )
    );
  });

  setTopRates$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetTopRates),
      switchMap((action: any) =>
        this.dashboardService.readTopRates(action.statisticFilter).pipe(
          map(
            (response: ReadTopRatesResponse) =>
              new DashboardActions.SetTopRatesSuccess(this.topRatesTransformerService.transform(response.topRates))
          ),
          catchError(error => of(new DashboardActions.SetTopRatesError(error)))
        )
      )
    );
  });

  setSubTopRatesHotel$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetSubTopRatesHotel),
      switchMap((action: any) =>
        this.dashboardService.readTopRatesHotel(action.statisticFilter, action.topRatesFilter, action.cityCode).pipe(
          map((response: any) => new DashboardActions.SetSubTopRatesHotelSuccess(response)),
          catchError(error => of(new DashboardActions.SetSubTopRatesHotelError(error)))
        )
      )
    );
  });

  setSubTopRatesCity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.SetSubTopRatesCity),
      switchMap((action: any) =>
        this.dashboardService.readTopRatesCity(action.statisticFilter, action.topRatesFilter, action.countryCode).pipe(
          map((response: any) => new DashboardActions.SetSubTopRatesCitySuccess(response)),
          catchError(error => of(new DashboardActions.SetSubTopRatesCityError(error)))
        )
      )
    );
  });

  
  requestBookingOffices$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.RequestBookingOffices),
      switchMap(() =>
        this.dashboardService.getBookingOffices().pipe(
          map(
            (response: BookingOfficesResponse) =>
              new DashboardActions.RequestBookingOfficesSuccess(response.bookingOffices)
          ),
          catchError(error => of(new DashboardActions.RequestBookingOfficesError(error)))
        )
      )
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<any>,
    private readonly dashboardService: BackendDashboardService,
    private readonly topRatesTransformerService: TopRatesTransformerService
  ) {}
}